import authHeader from "@/services/auth/AuthHeader";
import axios from "axios";

/**
 * AI online-ordering-site theme builder. The logged-in merchant (ADMIN) reads/writes their OWN
 * per-location theme schema; CagistaServices `/api/site/**` is tenant-isolated by the
 * SecurityCheckInterceptor (it checks the `merchant` we send matches the authenticated user).
 * `location` is the location's shortName (same value used in the Storefront URL + the schema key).
 */
class SiteThemeService {
    getSiteSchema(location){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/site/getSiteSchema?merchant=' + user.merchant + '&location=' + location;
        return axios.get(url, { headers: authHeader() });
    }

    /** The draft it is being edited as — the editor prefers this over the published page. */
    getSiteSchemaDraft(location){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/site/getSiteSchemaDraft?merchant=' + user.merchant + '&location=' + location;
        return axios.get(url, { headers: authHeader() });
    }

    /** Autosave. Changes nothing a guest sees — same word, same meaning, as on the Hjemmeside tab. */
    saveSiteSchema(location, schema){
        let user = JSON.parse(localStorage.getItem('user'));
        let payload = { merchant: user.merchant, location: location, schema: schema };
        return axios.post('/api/site/saveSiteSchema', payload, { headers: authHeader() });
    }

    /** Makes it live and archives a version. */
    publishSiteSchema(location, schema){
        let user = JSON.parse(localStorage.getItem('user'));
        let payload = { merchant: user.merchant, location: location, schema: schema };
        return axios.post('/api/site/publishSiteSchema', payload, { headers: authHeader() });
    }

    /** Throws the draft away and starts again from what is live. */
    discardDraft(location){
        let user = JSON.parse(localStorage.getItem('user'));
        let payload = { merchant: user.merchant, location: location };
        return axios.post('/api/site/discardSiteSchemaDraft', payload, { headers: authHeader() });
    }

    // AI generate: returns { schema, patch, note, model }. `merchant` is required so the tenant check passes.
    generate(prompt, schema){
        let user = JSON.parse(localStorage.getItem('user'));
        let payload = { merchant: user.merchant, prompt: prompt, schema: schema };
        return axios.post('/api/site/generate', payload, { headers: authHeader() });
    }

    // Recent version snapshots (newest first) for the version-history panel.
    getVersions(location){
        let user = JSON.parse(localStorage.getItem('user'));
        let url = '/api/site/getSiteSchemaVersions?merchant=' + user.merchant + '&location=' + location;
        return axios.get(url, { headers: authHeader() });
    }
}

export default new SiteThemeService();
